<template>
  <el-dialog
      v-if="isActivityActive"
      :visible.sync="dialogVisible"
      title=""
      width="400px"
      :show-close="true"
      class="promotion-dialog"
      :top="'28vh'"
  >
    <!-- 头部区域 -->
    <div class="dialog-header">
      <button class="close-btn" @click="closeDialog">×</button>
      <h1>{{ activityData.title }}</h1>
      <div class="discount-tag">{{ activityData.discountTag }}</div>
      <p class="sub-title">{{ activityData.subTitle }}</p>
    </div>

    <!-- 倒计时区域 -->
    <div class="countdown">
      {{ countdownText }}:
      <div class="countdown-box">
        <div class="time-item">{{ hours }}</div>
        <div class="time-label">小时</div>
      </div>
      <span class="colon">:</span>
      <div class="countdown-box">
        <div class="time-item">{{ minutes }}</div>
        <div class="time-label">分钟</div>
      </div>
      <span class="colon">:</span>
      <div class="countdown-box">
        <div class="time-item">{{ seconds }}</div>
        <div class="time-label">秒</div>
      </div>
    </div>

    <!-- 优惠列表 -->
    <ul class="promotion-list">
      <li class="list-item" v-for="(item, index) in activityData.promotionList" :key="index">
        <img :src="item.iconClass" alt="" style="width: 16px;padding-right: 5px;margin-top: 2px; color: #dddddd"></img>
        <span>{{ item.text }}</span>
      </li>
    </ul>

    <!-- 立即抢购按钮 -->
    <el-button
        class="buy-button"
        type="danger"
        size="large"
        @click="handleBuyNow"
    >
      {{ activityData.buttonText }}
    </el-button>

    <!-- 活动时间说明 -->
    <p class="activity-time">{{ activityData.activityTimeDesc }}</p>
  </el-dialog>
</template>

<script>
import discount from '@/assets/icon/discount.svg';
import welfare from '@/assets/icon/welfare.svg';
import seckill from '@/assets/icon/seckill.svg';
// import { getLatestOpenedActivity } from '@/api/index.js';

// 默认活动展示结构（接口无此字段时使用）
const defaultActivityData = () => ({
  title: '',
  discountTag: '限时参与',
  subTitle: '',
  promotionList: [
    { iconClass: discount, text: '直接折扣: 全场8折起，爆款低至5折' },
    { iconClass: welfare, text: '限时秒杀: 低价解锁，备考刚需闭眼入' },
    { iconClass: seckill, text: '超值福利: 开通/续费都能省，福利不中断' }
  ],
  buttonText: '立即抢购',
  activityTimeDesc: ''
});

export default {
  name: 'Promotion',
  data() {
    return {
      // 接口返回的当前开启的活动（有值且 status===1 时才显示弹框）
      latestActivity: null,
      // 活动展示数据（由接口数据填充）
      activityData: defaultActivityData(),

      // 弹窗显示状态
      dialogVisible: false,
      // 倒计时
      hours: '00',
      minutes: '00',
      seconds: '00',
      countdownText: '距离活动结束还剩',
      countdownTimer: null
    };
  },
  computed: {
    // 是否显示活动弹框：由接口 latestOpened 判断，有数据且 status===1 且在有效期内
    isActivityActive() {
      if (!this.latestActivity || this.latestActivity.status !== 1) return false;
      const now = Date.now();
      const start = new Date(this.latestActivity.startTime).getTime();
      const end = new Date(this.latestActivity.endTime).getTime();
      return now >= start && now <= end;
    }
  },
  methods: {
    formatNum(num) {
      return num.toString().padStart(2, '0');
    },

    // 根据接口数据填充 activityData
    fillActivityData(activity) {
      const base = defaultActivityData();
      this.activityData = {
        ...base,
        title: activity.title || base.title,
        subTitle: activity.subTitle || base.subTitle,
        discountTag: activity.subTitle || base.discountTag,
        activityTimeDesc: activity.startTime && activity.endTime
          ? `活动时间: ${activity.startTime} - ${activity.endTime}`
          : base.activityTimeDesc
      };
    },

    // 计算倒计时（使用接口的 endTime）
    calculateCountdown() {
      if (!this.latestActivity || !this.latestActivity.endTime) return;
      const endTime = new Date(this.latestActivity.endTime).getTime();
      const remainTime = endTime - Date.now();

      if (remainTime <= 0) {
        if (this.countdownTimer) clearInterval(this.countdownTimer);
        this.hours = '00';
        this.minutes = '00';
        this.seconds = '00';
        this.countdownText = '活动已结束';
        this.dialogVisible = false;
        return;
      }

      this.hours = this.formatNum(Math.floor(remainTime / (1000 * 60 * 60)));
      this.minutes = this.formatNum(Math.floor((remainTime % (1000 * 60 * 60)) / (1000 * 60)));
      this.seconds = this.formatNum(Math.floor((remainTime % (1000 * 60)) / 1000));
    },

    closeDialog() {
      this.dialogVisible = false;
    },

    handleBuyNow() {
      this.$router.push({ name: 'selfVIP' });
      this.dialogVisible = false;
    },

    async fetchLatestOpenedActivity() {
      try {
        const res = await getLatestOpenedActivity();
        if (res && res.code === '0000' && res.data && res.data.status === 1) {
          this.latestActivity = res.data;
          this.fillActivityData(res.data);
          return true;
        }
      } catch (e) {
        // 接口失败则不展示活动弹框
      }
      return false;
    }
  },
  async mounted() {
    // const hasActivity = await this.fetchLatestOpenedActivity();
    // if (!hasActivity || !this.isActivityActive) return;

    // // 每日首次访问才弹窗
    // const today = new Date().toISOString().slice(0, 10);
    // const lastDate = localStorage.getItem('promotionLastPopupDate');
    // if (lastDate !== today) {
    //   this.dialogVisible = true;
    //   localStorage.setItem('promotionLastPopupDate', today);
    // }

    // // 启动倒计时
    // this.calculateCountdown();
    // this.countdownTimer = setInterval(this.calculateCountdown, 1000);
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  }
};
</script>

<style scoped>
:deep(.promotion-dialog .el-dialog) {
  --el-dialog-padding-primary: 0 !important;
  padding: 0 !important;
  top: 58vh !important;
}

:deep(.el-dialog__header) {
  display: none !important;
}

:deep(.el-dialog__body) {
  padding: 16px !important;
}

.promotion-dialog {
  --el-dialog-bg-color: #fff;
  z-index: 9999 !important;
}

.dialog-header {
  background-color: #e63946;
  color: #fff;
  padding: 20px 24px 16px 24px;
  text-align: center;
  position: relative;
  margin: -16px -16px 20px -16px;
  width: calc(100% + 32px);
  box-sizing: border-box;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.dialog-header h1 {
  font-size: 24px;
  margin: 0 0 6px;
  font-weight: 600;
}

.discount-tag {
  background-color: #ffc300;
  color: #e63946;
  font-size: 12px;
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 4px;
  position: absolute;
  top: 12px;
  right: 44px;
}

.sub-title {
  font-size: 14px;
  margin: 0;
}

.countdown {
  background-color: #f1faee;
  padding: 20px 24px;
  text-align: center;
  margin: 0 0 16px 0;
  border-radius: 8px;
}

.countdown-box {
  display: inline-block;
  background-color: #2d3748;
  color: #fff;
  padding: 8px 6px;
  border-radius: 4px;
  margin: 0 3px;
  min-width: 36px;
}

.time-item {
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
}

.time-label {
  font-size: 10px;
  margin-top: 2px;
  opacity: 0.8;
}

.colon {
  font-size: 16px;
  margin: 0 4px;
}

.promotion-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-item {
  padding: 12px 24px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  transition: background-color 0.2s ease;
}

.list-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.list-item img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 3px;
}

.buy-button {
  width: 100%;
  background-color: #e63946;
  border-color: #e63946;
  margin: 16px 0 12px 0;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.buy-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(230, 57, 70, 0.3);
}

.activity-time {
  text-align: center;
  font-size: 12px;
  color: #666;
  margin: 0;
  padding: 8px 0 0 0;
  border-top: 1px solid #f0f0f0;
}
</style>
